import React from 'react';
import PropTypes from 'prop-types';
import {Match} from '@reach/router';
import clsx from "clsx";
import {AppRouters} from "settings";
import {DownArrowIcon, MyReportIcon, QuestionIcon, UserIcon} from "components/style-guide/icons";
import {Dropdown} from "components";

import styles from './HeaderActions.module.scss';

export const HeaderActions = ({isAuthenticated, onSignOut, checkNewReportStatus, userInfo}) => {
    return (
        <ul className={clsx("navbar-nav ml-auto align-items-center", styles.options)}>
            {
                !isAuthenticated
                    ? (
                        <>
                            <li className="nav-item">
                                <Match path={AppRouters.questions}>
                                    {props =>
                                        <span
                                            className={clsx("nav-link d-flex btn-clear align-items-center gap-1", {[styles.activeLink]: props.match})}
                                            onClick={() => checkNewReportStatus(AppRouters.questions)}>
                                            <QuestionIcon/> <span>Preguntas Frecuentes</span>
                                        </span>
                                    }
                                </Match>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link d-flex btn-clear  align-items-center gap-1" onClick={() => checkNewReportStatus(AppRouters.signIn)}>
                                    <UserIcon/> <span>Iniciar Sesión</span>
                                </span>
                            </li>
                        </>
                    )
                    : (
                        <>
                            <li className="nav-item">
                                <Match path={AppRouters.questions}>
                                    {props =>
                                        <span
                                            className={clsx("nav-link d-flex btn-clear align-items-center gap-1", {[styles.activeLink]: props.match})}
                                            onClick={() => checkNewReportStatus(AppRouters.questions)}>
                                            <QuestionIcon/> <span>Preguntas Frecuentes</span>
                                        </span>
                                    }
                                </Match>
                            </li>
                            <li className="nav-item">
                                <Match path={AppRouters.myReports}>
                                    {props =>
                                        <span
                                            className={clsx("nav-link d-flex btn-clear align-items-center gap-1", {[styles.activeLink]: props.match})}
                                            onClick={() => checkNewReportStatus(AppRouters.myReports)}>
                                            <MyReportIcon/> <span>Mis Reportes</span>
                                        </span>
                                    }
                                </Match>
                            </li>
                            <li className="nav-item">
                                <Dropdown
                                    onSelectItem={(item, index) => {
                                        if (item.id === 'sign-out') {
                                            return onSignOut();
                                        }

                                        checkNewReportStatus(item.id);
                                    }}
                                    items={[
                                        {label: "Mi Perfil", id: AppRouters.profile},
                                        {label: "Cerrar Sesión", id: 'sign-out'},
                                    ]}>

                                    <div className="d-flex btn-clear align-items-center gap-1">
                                        <UserIcon/>
                                        <span className="m-0 p-0">{userInfo?.fullName}</span>
                                        <DownArrowIcon className="ml-2" fontSize='small'/>
                                    </div>
                                </Dropdown>
                            </li>

                        </>
                    )
            }
        </ul>
    );
};

HeaderActions.propTypes = {
    isAuthenticated: PropTypes.bool,
    checkNewReportStatus: PropTypes.func,
    onSignOut: PropTypes.func
};

HeaderActions.defaultProps = {};

export default React.memo(HeaderActions);
